import * as CryptoJS from 'crypto-js';

export class CryptoExtension {
    private static secCode: string = 'smart@things!2020@HRMS***';
    private static secCodeAcc: string = 'smart@things!2020';
    private static keyEncode: string = 'itgreen';
    private static key: any;
    private static res: any = {
        reqtime: "",
        datastring: "",
        token: ""
    };
    static convertJson(
        data: string,
        reqid: string,
        reqtime: string,
        username: string
    ) {
        if (username == null) username = 'noname';
        var jsonstring = JSON.stringify(data);
        jsonstring = jsonstring
            .replace(/ /g, '')
            .replace(/\r/g, '')
            .replace(/\n/g, '')
            .replace(/\"/g, "'");
        return jsonstring + '#' + username + '#' + reqid + '#' + reqtime;
    }

    static encryptTable(table: string) {
        this.key = CryptoJS.MD5(this.secCode);
        this.key.words[4] = this.key.words[0];
        this.key.words[5] = this.key.words[1];
        var encrypted = CryptoJS.TripleDES.encrypt(table, this.key, {
            mode: CryptoJS.mode.ECB,
        });
        return encrypted.toString();
    }

    static decryptStr(str: string) {
        this.key = CryptoJS.MD5(this.secCode);
        this.key.words[4] = this.key.words[0];
        this.key.words[5] = this.key.words[1];
        const decrypted = CryptoJS.TripleDES.decrypt(
            str,
            this.key,
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            }
        );
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    static encryptHMAC(code: string, data: any, username: string) {
        this.res.reqtime = new Date().getTime();
        this.res.datastring = this.convertJson(data, code, this.res.reqtime, username);
        this.res.token = CryptoJS.HmacMD5(this.res.datastring, this.secCode).toString();
        return this.res;
    }
    static encryptHMACAcc(code: string, data: any, username: string) {
        this.res.reqtime = new Date().getTime();
        this.res.datastring = this.convertJson(data, code, this.res.reqtime, username);
        this.res.token = CryptoJS.HmacMD5(this.res.datastring, this.secCodeAcc).toString();
        return this.res;
    }

    static hashCode(code: string, data: string) {
        var jsonstring = code + '_' + JSON.stringify(data);
        return CryptoJS.HmacMD5(jsonstring, this.secCode).toString();
    }

    static hashCodeString(jsonstring: string) {
        return CryptoJS.HmacMD5(jsonstring, this.secCode).toString();
    }
    static encode(str: string) {
        return CryptoJS.AES.encrypt(str, this.keyEncode).toString();
    }
    static decode(str: string) {
        const decrypted = CryptoJS.AES.decrypt(str, this.keyEncode);
        if (decrypted) {
            try {
                const str = decrypted.toString(CryptoJS.enc.Utf8);
                if (str.length > 0) {
                    return str;
                } else {
                    return '';
                }
            } catch (e) {
                return '';
            }
        }
        return '';
    }
}
